<template>
  <small class="inactive-group">
    {{ labels.inactiveGroup }}
  </small>
</template>

<script>
export default {
  computed: {
    labels() {
      return this.$store.getters.resources.page.home.groups.dashboard
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.inactive-group {
  color: map-get($theme-colors, 'gray03');
  padding-left: 10px;
  text-transform: uppercase;
  font-size: 12px;
}
</style>
